<template>
  <registration-layout ref="form">
    <form
      class="new-registration vue"
      @submit.prevent="submit"
    >
      <h2>
        Dados Pessoais
      </h2>
      <p class="subheading">
        Complemente seu cadastro para agilizar o processo de aprovação
      </p>

      <brazil-text-field
        v-model="mother_name"
        name="mother_name"
        input-id="user_mother_name"
        label="Nome completo da sua mãe"
        :validator-field="$v.mother_name"
      />

      <brazil-radio-field
        name="gender"
        label="Sexo"
        :options="options.genders"
        :validator-field="$v.gender"
        autocomplete="gender"
      />

      <brazil-select-field
        name="educational_level"
        input-id="user_educational_level"
        label="Escolaridade"
        :options="options.educationalLevels"
        :validator-field="$v.educational_level"
      />

      <brazil-select-field
        name="nationality"
        input-id="user_nationality"
        label="Nacionalidade"
        :options="options.nationalities"
        :validator-field="$v.nationality"
      />

      <brazil-select-field
        name="birth_region"
        input-id="user_birth_region"
        label="Naturalidade"
        :options="options.birthRegions"
        :validator-field="$v.birth_region"
      />

      <brazil-select-field
        name="marital_status"
        input-id="user_marital_status"
        label="Estado Civil"
        :options="options.maritalStatuses"
        :validator-field="$v.marital_status"
      />

      <h2>Documento</h2>

      <brazil-select-field
        name="brazil_id_issuer"
        input-id="user_brazil_id_issuer"
        label="Tipo do documento"
        :options="options.brazilIdIssuers"
        :validator-field="$v.brazil_id_issuer"
      />

      <brazil-text-field
        v-model="brazil_id_number"
        name="brazil_id_number"
        input-id="user_brazil_id_number"
        type="tel"
        label="Número do documento"
        :validator-field="$v.brazil_id_number"
      />

      <brazil-text-field
        v-model="brazil_id_issued_on"
        name="brazil_id_issued_on"
        input-id="user_brazil_id_issued_on"
        type="tel"
        label="Data de emissão"
        placeholder="dd/mm/aaaa"
        :mask="dateMask"
        maxlength="10"
        :validator-field="$v.brazil_id_issued_on"
      />

      <brazil-select-field
        name="brazil_id_region"
        input-id="user_brazil_id_region"
        label="Estado de emissão"
        :options="options.states"
        :validator-field="$v.brazil_id_region"
      />

      <h2>Endereço</h2>

      <brazil-text-field
        v-model="zipcode"
        name="postal_code"
        input-id="user_zipcode"
        type="tel"
        label="CEP"
        autocomplete="postal-code"
        placeholder="_____-___"
        :mask="zipcodeMask"
        maxlength="9"
        :validator-field="$v.zipcode"
      >
        <template v-slot:note>
          <br><a
            target="_blank"
            href="http://www.buscacep.correios.com.br/sistemas/buscacep/"
          >Não sei meu cep</a>
        </template>
      </brazil-text-field>

      <brazil-text-field
        v-model="street_address"
        name="address_line1"
        input-id="user_street_address"
        label="Endereço"
        autocomplete="address-line1"
        :validator-field="$v.street_address"
      />

      <brazil-text-field
        v-model="street_number"
        name="address_line2"
        input-id="user_street_number"
        label="Número"
        autocomplete="address-line2"
        :validator-field="$v.street_number"
      />

      <brazil-text-field
        v-model="additional_info"
        name="address_line3"
        input-id="user_additional_info"
        label="Complemento"
        autocomplete="address-line3"
        :validator-field="$v.additional_info"
      />

      <brazil-text-field
        v-model="city"
        name="city"
        input-id="user_city"
        label="Cidade"
        autocomplete="city"
        :validator-field="$v.city"
      />

      <brazil-select-field
        name="state"
        input-id="user_state"
        label="Estado"
        :options="options.states"
        :validator-field="$v.state"
      />

      <brazil-select-field
        name="time_at_address"
        input-id="user_time_at_address"
        label="Tempo na residência"
        :options="options.timeAtAddress"
        :validator-field="$v.time_at_address"
      />

      <brazil-select-field
        name="residence_type"
        input-id="user_residence_type"
        label="Tipo de residência"
        :options="options.residenceTypes"
        :validator-field="$v.residence_type"
      />

      <brazil-text-field
        v-if="!hasMainPhoneNumber"
        v-model="main_phone"
        name="tel"
        input-id="user_main_phone"
        type="tel"
        label="Telefone celular"
        autocomplete="tel"
        placeholder="(__) ____-____"
        :mask="phoneMask"
        maxlength="15"
        :validator-field="$v.main_phone"
      />

      <brazil-text-field
        v-model="home_phone"
        name="home_phone"
        input-id="user_home_phone"
        type="tel"
        label="Telefone secundário"
        autocomplete="tel"
        placeholder="(__) _____-____"
        :mask="phoneMask"
        maxlength="15"
        :validator-field="$v.home_phone"
      />

      <!-- field spacer -->
      <div class="registration-field" />

      <div class="form-group">
        <div class="panel-body unpadded confirmations">
          <div v-if="!hasValidScrConsent">
            <!-- eslint-disable max-len -->
            <input
              id="user_privacy_policy_text"
              name="privacy_policy_text"
              type="hidden"
              value="Li, compreendi e concordo com a <a href=&quot;/politica_de_privacidade&quot; target=&quot;_blank&quot;>Política de Privacidade e a Política de Segurança</a>, bem como a consultar quaisquer informações a meu respeito nos sistemas dos serviços de informações e proteção ao crédito e no Sistema de Informações de Crédito – SCR – do Banco Central do Brasil."
            >
            <brazil-checkbox-field
              v-if="!hasValidScrConsent"
              name="privacy_policy"
              class="privacy-policy"
              input-id="user_privacy_policy"
              label="Li, compreendi e concordo com a <a href=&quot;/politica_de_privacidade&quot; target=&quot;_blank&quot;>Política de Privacidade e a Política de Segurança</a>, bem como a consultar quaisquer informações a meu respeito nos sistemas dos serviços de informações e proteção ao crédito e no Sistema de Informações de Crédito – SCR – do Banco Central do Brasil."
              true-value="1"
              false-value="0"
              :validator-field="$v.privacy_policy"
            />
            <!-- eslint-enable max-len -->
          </div>
          <div v-if="showWhatsappConsent">
            <!-- eslint-disable max-len -->
            <input
              id="user_whatsapp_consent_text"
              name="whatsapp_consent_text"
              type="hidden"
              value="Aceito receber informações por <strong>Whatsapp</strong> sobre minha conta Simplic"
            >
            <brazil-checkbox-field
              name="whatsapp_consent"
              input-id="user_whatsapp_consent"
              label="Aceito receber informações por <strong>Whatsapp</strong> sobre minha conta Simplic"
              true-value="1"
              false-value="0"
              :validator-field="$v.whatsapp_consent"
              label-class="whatsapp-consent"
              wrapper-class="whatsapp_consent_wrapper"
              :checked="false"
            >
              <!-- eslint-enable max-len -->
              <template v-slot:icon>
                <div class="whatsapp-consent-icon">
                  <span class="whatsapp-consent-icon-container">
                    <span class="whatsapp-consent-icon-circle">
                      <img
                        class="whatsapp-icon"
                        src="~images/whatsapp-icon-white.png"
                        alt="whatsapp icon"
                      >
                    </span>
                  </span>
                </div>
              </template>
            </brazil-checkbox-field>
          </div>

          <div v-if="showPositiveCreditDataConsent">
            <!-- eslint-disable max-len -->
            <input
              id="user_positive_credit_data_consent_text"
              name="positive_credit_data_consent_text"
              type="hidden"
              value="Eu autorizo a LH1010 e a LH1003 (Simplic) a acessar os meus dados de histórico financeiro em base de dados conforme a Lei nº 12.414 de 9 de junho de 2011, nos termos da autorização <a id='positive-credit-data-consent-modal-toggle'>deste link</a>"
            >
            <brazil-checkbox-field
              name="positive_credit_data_consent"
              input-id="user_positive_credit_data_consent"
              true-value="1"
              false-value="0"
              :validator-field="$v.positive_credit_data_consent"
              label-class="positive-credit-data-consent"
              wrapper-class="positive_credit_data_consent_wrapper"
              :checked="false"
            >
              <template v-slot:label>
                Eu autorizo a LH1010 e a LH1003 (Simplic) a acessar os meus dados de histórico financeiro em base de dados conforme a Lei nº 12.414 de 9 de junho de 2011, nos termos da autorização <a
                  id="positive-credit-data-consent-modal-toggle"
                  @click="openPositiveCreditDataConsentModal()"
                >deste link</a>
              </template>
            </brazil-checkbox-field>
            <!-- eslint-enable max-len -->
          </div>
        </div>
      </div>

      <hr>

      <div class="registration-field">
        <div class="form-group">
          * Preenchimento obrigatório
        </div>
      </div>

      <RegistrationNextButton
        ref="submitButton"
      />
    </form>
    <positive-credit-data-consent-modal
      v-if="showPositiveCreditDataConsentModal"
      :show-dialog="showPositiveCreditDataConsentModal"
      @closeModal="closePositiveCreditDataConsentModal"
    />
  </registration-layout>
</template>

<script>
import { get, sync, call } from 'vuex-pathify';
import {
  required,
  integer,
} from 'vuelidate/lib/validators';
import {
  minimumZipcodeLength,
  phoneNumberLength,
  secondaryPhoneNumberLength,
  laterThanDate,
  internationalDate,
  privacyPolicyAgreed,
} from '../validators';
import BrazilTextField from '../components/fields/BrazilTextField.vue';
import BrazilRadioField from '../components/fields/BrazilRadioField.vue';
import BrazilSelectField from '../components/fields/BrazilSelectField.vue';
import BrazilCheckboxField from '../components/fields/BrazilCheckboxField.vue';
import PositiveCreditDataConsentModal from '../components/PositiveCreditDataConsentModal.vue';
import RegistrationNextButton from '../components/RegistrationNextButton.vue';
import RegistrationLayout from '../layouts/RegistrationLayout.vue';
import {
  genders,
  educationalLevels,
  nationalities,
  birthRegions,
  maritalStatuses,
  brazilIdIssuers,
  states,
  timeAtAddress,
  residenceTypes,
} from '../config/options';
import {
  dateMask,
  zipcodeMask,
  phoneMask,
} from '../config/masks';
import captureRenderBlockingException from '../tracking/helpers/captureRenderBlockingException';
import trackFormCompletedEvent from '../lib/analytics/trackHelpers/trackFormCompletedEvent';
import { trackMaxScrollDepth } from '../lib/analytics/trackHelpers/trackScrollDepth';
import {
  addAllBehaviorTrackingListeners,
  removeAllBehaviorTrackingListeners,
} from '../lib/analytics/trackHelpers/eventListeners';
import analytics from '../lib/analytics';
import { trackEvent } from '../lib/optimizely';

export default {
  components: {
    RegistrationLayout,
    RegistrationNextButton,
    BrazilTextField,
    BrazilRadioField,
    BrazilSelectField,
    BrazilCheckboxField,
    PositiveCreditDataConsentModal,
  },
  data() {
    return {
      options: {
        genders,
        educationalLevels,
        nationalities,
        birthRegions,
        maritalStatuses,
        brazilIdIssuers,
        states,
        timeAtAddress,
        residenceTypes,
      },
      dateMask,
      zipcodeMask,
      phoneMask,
      showWhatsappConsent:                false,
      showPositiveCreditDataConsent:      false,
      showPositiveCreditDataConsentModal: false,
      startTime:                          new Date().toISOString(),
    };
  },
  computed: {
    ...sync('registration', [
      'reg1@main_phone',
      'reg1@privacy_policy',
      'reg1@privacy_policy_text',
      'reg1@whatsapp_consent',
      'reg1@whatsapp_consent_text',
      'reg1@positive_credit_data_consent',
      'reg1@positive_credit_data_consent_text',
      'reg2@mother_name',
      'reg2@gender',
      'reg2@educational_level',
      'reg2@nationality',
      'reg2@birth_region',
      'reg2@marital_status',
      'reg2@brazil_id_issuer',
      'reg2@brazil_id_number',
      'reg2@brazil_id_issued_on',
      'reg2@brazil_id_region',
      'reg2@zipcode',
      'reg2@street_address',
      'reg2@street_number',
      'reg2@additional_info',
      'reg2@city',
      'reg2@state',
      'reg2@time_at_address',
      'reg2@residence_type',
      'reg2@home_phone',
    ]),
    ...get('registration', [
      'reg1@date_of_birth',
      'hasValidScrConsent',
      'hasMainPhoneNumber',
      'hasWhatsappConsent',
      'hasPositiveCreditDataConsent',
    ]),
    ...get([
      'backendErrors',
      'backendErrorMessages',
    ]),
    hasValidZipcode() {
      return this.$v.zipcode.$invalid === false;
    },
  },
  watch: {
    async zipcode(newValue, oldValue) {
      if (newValue) {
        const updated = newValue.replace('-', '') !== oldValue.replace('-', '');
        if (this.hasValidZipcode && updated) {
          const updatedFields = await this.fetchZipCodes();
          this.lodash.each(updatedFields, (field) => {
            this.$v[field].$touch();
          });
        }
      }
    },
  },
  mounted() {
    try {
      const accountId = this.$store.get('account').account_id;
      trackEvent('reg2_visited', accountId);
      this.$store.dispatch('registration/setCurrentStepNumber', 2);
      if (this.backendErrorMessages) {
        this.flash(this.backendErrorMessages, 'error');
      }
      analytics.page();
      addAllBehaviorTrackingListeners();
    } catch (e) {
      this.$store.dispatch('setBackendErrorMessage');
      this.flash(this.backendErrorMessages, 'error');
      captureRenderBlockingException(e);
    }
    if (!sessionStorage.seenWhatsappThisSession && !this.hasWhatsappConsent) {
      this.showWhatsappConsent = true;
    }
    if (!this.hasPositiveCreditDataConsent) {
      this.showPositiveCreditDataConsent = true;
    }
  },
  destroyed() {
    removeAllBehaviorTrackingListeners();
  },
  methods: {
    submitReg2:    call('registration/submitReg2'),
    fetchZipCodes: call('registration/fetchZipCodes'),
    async submit() {
      if (this.$v.$invalid || this.$v.$pending) {
        this.$v.$touch();
        this.$refs.submitButton.shakeDisableButton();
        this.$refs.form.focusFirstError();
      } else {
        this.flash().destroyAll();
        try {
          await this.submitReg2();
          if (this.backendErrors) {
            this.flash(this.backendErrorMessages.join('<br>'), 'error');
          } else {
            trackFormCompletedEvent('reg2', this.startTime);
            trackMaxScrollDepth('reg2');
            this.$router.push('financeiro');
          }
        } catch (e) {
          this.flash(this.backendErrorMessages, 'error');
        }
      }
    },
    openPositiveCreditDataConsentModal() {
      this.showPositiveCreditDataConsentModal = true;
    },
    closePositiveCreditDataConsentModal() {
      this.showPositiveCreditDataConsentModal = false;
    },
  },
  validations() {
    return {
      main_phone: {
        required,
        phoneNumberLength,
      },
      privacy_policy: {
        privacyPolicyAgreed,
      },
      privacy_policy_text: {
        required: false,
      },
      whatsapp_consent_text: {
        required: false,
      },
      whatsapp_consent: {
        required: false,
      },
      positive_credit_data_consent_text: {
        required: false,
      },
      positive_credit_data_consent: {
        required: this.showPositiveCreditDataConsent,
      },
      mother_name: {
        required,
      },
      gender: {
        required,
      },
      birth_region: {
        required,
      },
      brazil_id_number: {
        required,
        integer,
      },
      brazil_id_issuer: {
        required,
      },
      brazil_id_issued_on: {
        required,
        internationalDate,
        laterThanBirthDate: laterThanDate(this.date_of_birth),
      },
      brazil_id_region: {
        required,
      },
      zipcode: {
        required,
        minimumZipcodeLength,
      },
      street_address: {
        required,
      },
      street_number: {
        required,
      },
      additional_info: {
      },
      city: {
        required,
      },
      state: {
        required,
      },
      home_phone: {
        secondaryPhoneNumberLength,
      },
      marital_status: {
        required,
      },
      educational_level: {
        required,
      },
      nationality: {
        required,
      },
      residence_type: {
        required,
      },
      time_at_address: {
        required,
      },
    };
  },
};
</script>

<style scoped>
  form {
    padding: 1rem;
  }
  .confirmations {
    margin-top: 30px;
  }
  #positive-credit-data-consent-modal-toggle {
    text-decoration: none;
    font-weight: 600;
  }
  .subheading {
    color: #333333;
  }
  .form-group {
  color: #333333;
}
</style>
